import { useContext, useState } from "react";
import { ToastContext } from "../../../../hooks/context";
import { useSendPOEmailMutation } from "../../../../hooks/api/mutations";

export const usePOSendEmail = ({ pODetails, closeModal = () => {} }) => {
  const triggerToast = useContext(ToastContext);
  const [formData, setFormData] = useState({
    supplier_name: pODetails?.supplier?.name || "",
    supplier_email: pODetails?.supplier?.email || "",
  });

  const { mutate: sendPO, isLoading: isSendingPo } = useSendPOEmailMutation();

  const handleSendEmail = () => {
    sendPO(
      { id: pODetails?.id, data: formData },
      {
        onSuccess: () => {
          triggerToast(
            `P.O. with No.: ${pODetails?.po_number} sent to supplier successfully`,
            "success",
          );
          closeModal();
        },
      },
    );
  };

  return {
    isSendingPo,
    formData,
    setFormData,
    handleSendEmail,
  };
};
